import React from 'react'
import {withRouter} from 'react-router-dom'
import {Button, Label, Media, Row} from 'reactstrap'
import {AvFeedback, AvForm, AvGroup, AvInput} from 'availity-reactstrap-validation'
import {authenticationHelpers} from "../../../dataHelpers"
import {pageHelpers} from '../'
import SFLogo from '../../../images/sf-logo-horizontal.png'
import '../../../stylesheets/Authentication.css'

class SignUpPage extends React.Component {
    constructor(props) {
        super(props)
        pageHelpers.setupPropsForPage(props, this)

        let expired = false
        if (this.queryParams.e) {
            let expireTime = parseInt(this.queryParams.e)
            let now = Math.round((new Date()).getTime() / 1000)
            expired = (now >= expireTime)
        }

        this.state = {
            expired,
            errors: []
        }

        if (authenticationHelpers.isAuthenticated()) {
            this.history.push(`/controllers`)
        }

        this.handleValidSubmit = this.handleValidSubmit.bind(this)
    }

    componentWillMount() {
        pageHelpers.setupSingleRunAnimationEvents()
    }

    componentWillUnmount() {
        pageHelpers.tearDownSingleRunAnimationEvents()
    }

    componentWillReceiveProps(nextProps) {
        pageHelpers.setupPropsForPage(nextProps, this)

        let expired = false
        if (this.queryParams.e) {
            let expireTime = parseInt(this.queryParams.e)
            let now = Math.round((new Date()).getTime() / 1000)
            expired = (now >= expireTime)
        }

        this.setState({expired})
    }

    async handleValidSubmit(event, values) {
        event.preventDefault()
        let {firstName, lastName, password} = values

        let userID = this.queryParams.u
        let signUpCode = this.queryParams.c
        let signUpResponse = await authenticationHelpers.signUp(firstName,
                                                                 lastName,
                                                                 password,
                                                                 userID,
                                                                 signUpCode,
                                                                 this.history)
        if (signUpResponse.error) {
            this.setState({errors: [signUpResponse.error]})
        } else {
            this.history.push("/login")
        }
    }

    render() {
        let {expired, errors} = this.state

        return <Row className="justify-content-center">
            {expired ?
                <h1>This link has expired. Please contact your team administrator.</h1> :
                <AvForm onValidSubmit={this.handleValidSubmit}
                        onInvalidSubmit={pageHelpers.handleInvalidFormSubmit}
                        model={this.initialFormValues}
                        className="col-md-6 col-sm-10 text-left">
                    <div className="text-center mb-4">
                        <Media object className="col-10 mb-4" src={SFLogo} alt="SureFire Ag Logo"/>
                        <h2 className="mb-4">Activate your Marksman account</h2>
                    </div>
                    <AvGroup>
                        <Label for="firstName">First Name</Label>
                        <AvInput name="firstName"
                                 placeholder="First Name"
                                 type="text"
                                 autoComplete="given-name"
                                 required/>
                        <AvFeedback>Please enter your first name.</AvFeedback>
                    </AvGroup>
                    <AvGroup>
                        <Label for="lastName">Last Name</Label>
                        <AvInput name="lastName"
                                 placeholder="Last Name"
                                 type="text"
                                 autoComplete="family-name"
                                 required/>
                        <AvFeedback>Please enter your last name.</AvFeedback>
                    </AvGroup>
                    <AvGroup>
                        <Label for="password">Password</Label>
                        <AvInput name="password"
                                 placeholder="********"
                                 type="password"
                                 autoComplete="new-password"
                                 validate={{minLength: {value: 8}}}
                                 required/>
                        <AvFeedback>Please enter a password (at least 8 characters long.)</AvFeedback>
                    </AvGroup>
                    <AvGroup className="mb-4">
                        <Label for="confirmPassword">Confirm Password</Label>
                        <AvInput name="confirmPassword"
                                 placeholder="********"
                                 type="password"
                                 autoComplete="new-password"
                                 validate={{match: {value: 'password'}}}
                                 required/>
                        <AvFeedback>Passwords do not match</AvFeedback>
                    </AvGroup>
                    <AvGroup>
                        <Button className="col-4 offset-8">Activate Account</Button>
                    </AvGroup>
                </AvForm>}
            {pageHelpers.renderErrorModalsForPage(errors, this)}
        </Row>
    }
}

export default withRouter(SignUpPage)



// WEBPACK FOOTER //
// ./src/components/pages/authentication/SignUpPage.js